<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div *ngIf="ticket$ | async" class="full-height">
	<docked-ticket
		[ticketId]="(ticket$ | async).$id"
		[ticket$]="ticket$"
		[plan$]="plan$"
		[roles$]="ticketService.roles$"
		[locations$]="ticketService.locations$"
		[projectMembers$]="ticketService.projectMembers$"
		[priorityList$]="ticketService.priorityList$"
		[varianceList$]="ticketService.varianceList$"
		[ticketContext]="ticketContext"
		[customFieldsApi]="ticketService.customFieldsApi"
		[allowList$]="planService.allowedProjectLinks$"
		[calendarWorkdays]="ticketService.calendarWorkdays"
		[planAccessCheck]="ticketService.planAccessCheck"
		(ticketDataChanged)="ticketDataChanged($event)"
		(persistTicketData)="persistTicket($event)"
		(revertToDatabase)="resetTicketToDatabase($event)"
		(shouldClose)="goToTicketList($event)"
	>
	</docked-ticket>
</div>
